import React from 'react'
import { Card, Row, Col, Statistic } from 'antd'
import {
    UserOutlined,
    ShopOutlined,
    ShoppingOutlined,
    DollarOutlined,
    RiseOutlined,
    FallOutlined,
} from '@ant-design/icons'

export const KeyMetricsGrid: React.FC = () => {
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={6}>
                <Card>
                    <Statistic
                        title="Total Users"
                        value={1234}
                        prefix={<UserOutlined />}
                        suffix={<RiseOutlined style={{ color: '#3f8600', fontSize: 14 }} />}
                        valueStyle={{ color: '#3f8600' }}
                    />
                    <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>
                        +12% from last month
                    </div>
                </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
                <Card>
                    <Statistic
                        title="Active Merchants"
                        value={567}
                        prefix={<ShopOutlined />}
                        suffix={<RiseOutlined style={{ color: '#3f8600', fontSize: 14 }} />}
                        valueStyle={{ color: '#7c3aed' }}
                    />
                    <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>
                        +8% from last month
                    </div>
                </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
                <Card>
                    <Statistic
                        title="Total Orders"
                        value={198}
                        prefix={<ShoppingOutlined />}
                        suffix={<FallOutlined style={{ color: '#cf1322', fontSize: 14 }} />}
                        valueStyle={{ color: '#1890ff' }}
                    />
                    <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>
                        -3% from last month
                    </div>
                </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
                <Card>
                    <Statistic
                        title="Revenue"
                        value={750000}
                        prefix={<DollarOutlined />}
                        suffix={<RiseOutlined style={{ color: '#3f8600', fontSize: 14 }} />}
                        precision={0}
                        valueStyle={{ color: '#cf1322' }}
                    />
                    <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>
                        +15% from last month
                    </div>
                </Card>
            </Col>
        </Row>
    )
}
